import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from '../store'
Vue.use(VueRouter);
import jwt_decode from "jwt-decode";
// configure router

const router = new VueRouter({
  mode:"history",
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  // debugger;
  const currentUser = store.getters['user/getUserData'];
  const authToken = store.getters['user/getToken'];
  const publicPages = ['/auth/login', '/auth/home', '/auth/lock', '/auth/register', '/auth/forgotpassword'];
  const authRequired = !publicPages.includes(to.path);
  try {
    if (authRequired) {
      if (!authToken) {
        return next(`/auth/login?redirect=${to.path}`);
      }
      var decoded = jwt_decode(authToken);
      if (Date.now() >= decoded.exp * 1000) {
        return next(`/auth/lock?redirect=${to.path}`);
      }
    }



    // if (authRequired && !loggedIn) {
    //   return next('/home');
    // }

    next();
  } catch (e) {
    store.dispatch('user/setJWTToken', '')
    // window.location = window.location.origin + '/login'
    // throw "Your Session has expired! Please login Again";
    // return next('/login');


    next();
  }


})
export default router;
